import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { PermissionsService } from '@shared/services/permissions.service';
import { authActions, authState } from '@sleipai/sleip-ngrx-store';
import { map } from 'rxjs';

export const canActivateWebAppLidskjalvGuard: CanActivateFn = () => {
  const store = inject(Store<authState.State>);
  const permissionService = inject(PermissionsService);
  const destroyRef = inject(DestroyRef);

  return permissionService.canActivateWebAppLidskjalv().pipe(
    takeUntilDestroyed(destroyRef),
    map((webAppLidskjalvAccess) => {
      if (webAppLidskjalvAccess) {
        return true;
      } else {
        store.dispatch(authActions.logoutUser());
        store.dispatch(authActions.showNotAuthorizedForLidskjalvDialog());
        return false;
      }
    }),
  );
};
